import {
  BaseOrdersClient,
  OrderHistory,
  OrderReviewType,
  ORDERS_HISTORY_PARAMS,
  OrderTracking,
  OrderTrackingPayload,
} from "@core/types";
import { TOrder, CreateOrderData, CreatePaymentPayload, PaymentFormData } from "@core/types";
import { IrsKomOrderHistory, IrsKomOrderHistoryItem, IrsKomOrderSubmitResponseData } from "./types";
import { convertOrderHistory, convertOrderHistoryDetails, convertTORderToIrskomReqBody } from "./converters";

class OrdersClient extends BaseOrdersClient {
  async getUnpaidOrdersId(): Promise<TOrder["id"][]> {
    throw new Error("createPayment not implemented");
  }

  async getOrders(): Promise<TOrder[]> {
    const response = await this.instance.get<IrsKomOrderHistory[]>("/order/history");

    return response.data.map(convertOrderHistory);
  }

  async getOrderById(id: string | number): Promise<TOrder> {
    const [itemRes, orderRes] = await Promise.all([
      this.instance.get<IrsKomOrderHistoryItem[]>("/order/history/items", {
        params: {
          orderId: id,
        },
      }),
      this.instance.get<IrsKomOrderHistory>("/order/history/order", {
        params: {
          orderId: id,
        },
      }),
    ]);

    return convertOrderHistoryDetails(itemRes.data, orderRes.data);
  }

  async createOrder(order: CreateOrderData): Promise<TOrder> {
    const irsKomOrderReqBody = convertTORderToIrskomReqBody(order);

    const response = await this.instance.post<IrsKomOrderSubmitResponseData>("/order/submit", irsKomOrderReqBody);

    return {
      ...order,
      id: response.data.id,
      number: response.data.number,
    };
  }

  async createPayment(payload: CreatePaymentPayload): Promise<PaymentFormData> {
    const response = await this.instance.get<PaymentFormData>("order/sber/payment", {
      params: payload,
    });

    return response.data;
  }

  async getReviewSetOrderById(orderId: string): Promise<OrderReviewType> {
    throw new Error("getReviewSetOrderById is not implemented");
  }

  async addReviewOrder(orderReqData: OrderReviewType): Promise<OrderReviewType> {
    throw new Error("getReviewSetOrderById is not implemented");
  }

  async getOrdersHistory(params: ORDERS_HISTORY_PARAMS): Promise<OrderHistory[]> {
    throw new Error("getOrdersHistory is not implemented");
  }

  async getOrderTracking(orderReqData: OrderTrackingPayload): Promise<OrderTracking | null> {
    throw new Error("getOrderTracking is not implemented");
  }
  async orderCancel(orderId: string): Promise<Partial<TOrder>> {
    throw new Error("orderCancel is not implemented");
  }
  async createTaxiOrder(orderId: TOrder["id"]): Promise<any> {
    throw new Error("createTaxiOrder is not implemented");
  }
}

export default OrdersClient;
